import * as z from "zod";
import { OC } from "../../utils";
import { AdminFinance } from "./schema";

export const financeContract = OC.router({
  // KPIs
  getTotalHeld: OC.meta({ permissions: true }).output(z.number()),
  getTotalDue: OC.meta({ permissions: true }).output(z.number()),
  getTotalRevenue: OC.meta({ permissions: true }).input(AdminFinance.DateRange).output(z.number()),
  getTotalRefunds: OC.meta({ permissions: true }).input(AdminFinance.DateRange).output(z.number()),

  // Trends
  getPaymentsOverTime: OC.meta({ permissions: true })
    .input(AdminFinance.DateRange)
    .output(z.array(AdminFinance.TimeSeriesDataPoint)),
  getRefundsOverTime: OC.meta({ permissions: true })
    .input(AdminFinance.DateRange)
    .output(z.array(AdminFinance.TimeSeriesDataPoint)),

  // Breakdowns
  getPaymentMethodBreakdown: OC.meta({ permissions: true })
    .input(AdminFinance.DateRange)
    .output(z.array(AdminFinance.BreakdownDataPoint)),
  getPaymentStatusBreakdown: OC.meta({ permissions: true })
    .input(AdminFinance.DateRange)
    .output(z.array(AdminFinance.BreakdownDataPoint)),

  // Ledger
  getPayments: OC.meta({ permissions: true })
    .input(AdminFinance.PaymentsFilters)
    .output(z.array(AdminFinance.PaymentEntry)),

  countPayments: OC.meta({ permissions: true })
    .input(
      AdminFinance.PaymentsFilters.omit({
        page: true,
        limit: true,
        sortBy: true,
        sortOrder: true,
      }),
    )
    .output(z.number()),
});
